import { extendVariants, Tooltip as HeroTooltip, TooltipProps } from '@heroui/react';
import { twMerge } from 'tailwind-merge';

import { HeroBaseProps } from '../utils';

// For all Tooltip props see https://v2.heroui.com/docs/components/tooltip
export const Tooltip = extendVariants(
  (
    props: HeroBaseProps<TooltipProps, 'content' | 'placement' | 'isDisabled' | 'isOpen' | 'showArrow'> & {
      color?: 'primary' | 'secondary';
    },
  ) => {
    return (
      <HeroTooltip
        {...props}
        showArrow={props.showArrow ?? true}
        size="lg"
        radius="sm"
        classNames={{
          ...props.classNames,
          // Default width cap; consumers can override by passing `classNames.content` (merged last).
          content: twMerge('antialiased max-w-xs px-4 py-2 text-sm', props.classNames?.content),
          base: twMerge('before:rounded-[2px]', props.classNames?.base),
        }}
      />
    );
  },
  {
    defaultVariants: { color: 'primary' },
    variants: {
      color: {
        primary: {
          base: [
            // arrow color
            'before:bg-secondary-900',
          ],
          content: 'bg-secondary-900 text-white',
        },
        secondary: {
          base: [
            // arrow color
            'before:bg-secondary-100',
          ],
          content: 'bg-secondary-100 text-secondary-900',
        },
      },
    },
  },
);

export type TooltipPlacement = TooltipProps['placement'];
